import { render, staticRenderFns } from "./AnswerExamDetail.vue?vue&type=template&id=0d760d9c&scoped=true"
import script from "./AnswerExamDetail.vue?vue&type=script&lang=js"
export * from "./AnswerExamDetail.vue?vue&type=script&lang=js"
import style0 from "./AnswerExamDetail.vue?vue&type=style&index=0&id=0d760d9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d760d9c",
  null
  
)

export default component.exports